import { render, staticRenderFns } from "./index.vue?vue&type=template&id=401cafb4&scoped=true&lang=html&"
import script from "./storeList.js?vue&type=script&lang=js&"
export * from "./storeList.js?vue&type=script&lang=js&"
import style0 from "./storeList.styl?vue&type=style&index=0&lang=stylus&"
import style1 from "./resetVant.styl?vue&type=style&index=1&id=401cafb4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401cafb4",
  null
  
)

export default component.exports